import { z } from './zod.js';
export const successResponse = () => {
    return z.object({
        success: z.boolean().openapi({ example: true }),
    });
};
export const errorResponse = (message) => {
    return z.object({
        success: z.boolean().openapi({ example: false }),
        code: z.string().optional(),
        message: z.string().openapi({
            example: message,
        }),
    });
};
export const errorCodeResponse = (code, message) => {
    return z.object({
        success: z.literal(false).openapi({ example: false }),
        code: z.literal(code),
        message: z.string().openapi({
            example: message,
        }),
    });
};
export const errorAnyCodeResponse = (message) => {
    return z.object({
        success: z.literal(false).openapi({ example: false }),
        code: z.string(),
        message: z.string().openapi({
            example: message,
        }),
    });
};
export const listResponse = (schema) => {
    return z.object({
        success: z.boolean().openapi({ example: true }),
        data: z.array(schema),
    });
};
export const deleteResponse = () => {
    return z.object({
        success: z.boolean().openapi({ example: true }),
    });
};
export const dataResponse = (schema) => {
    return z.object({
        success: z.boolean().openapi({ example: true }),
        data: schema,
    });
};
